module.exports = __webpack_public_path__ + "static/media/logo_04.db53f61a.png";